import React from 'react';
import { number, node, bool } from 'prop-types';
import styles from './progressBar.module.css';

const calculateProgress = (current, total) =>
  (current > 0 ? Math.floor(((current) / (total)) * 100) : 0);

const ProgressBar = ({
  current, total, children, stripes
}) => (
  <div className={styles.progressBarContainer}>
    <div className={styles.progressBar}>
      <div className={`${styles.progressBarValue} ${stripes ? styles.stripes : ''}`} style={{ width: `${calculateProgress(current, total)}%` }} />
      {children}
    </div>
  </div>
);

ProgressBar.propTypes = {
  current: number.isRequired,
  total: number.isRequired,
  children: node,
  stripes: bool
};

ProgressBar.defaultProps = {
  stripes: false,
  children: null
};

export default ProgressBar;
